import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  getAppAction,
  getLoginInfo,
  getSearchInfo,
  setEtdToken,
} from '../../../shared/utils/storage';
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { createNotification } from '../../../shared/components/Popup';

const ViewHistoryComponent = () => {
  const [application, setApplication] = useState();

  useEffect(() => {
    const searchedData = getSearchInfo();
    if (searchedData) {
      getUserHistory(searchedData?.data);
    }
  }, []);
  const navigate = useNavigate();
  // const location = useLocation()
  // const newData = location.state

  const [recommendation, setRecomendation] = useState([]);
  const [userHistory, setUserHistory] = useState([]);

  // const [RoutbackCheck, setRoutbackCheck] = useState("1");
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const styles = {
    h4: {
      color: "#850505",
      // textTransform: 'uppercase',
    },
  };
  // useEffect(() => {
  //   getUserHistory()
  // }, [])

  const getUserHistory = async (newData) => {
    const stageID = newData?.ApplicationStatus[0]?.StageID;
    const applicationID = newData?.ApplicationStatus[0]?.ApplicationID;
    const payload = {
      ApplicationId: applicationID,
      Action: "History",
      StageId: stageID,
      Station: getLoginInfo()?.user?.StationID,
      UserName: getLoginInfo()?.user?.Username,
    };

    const result = await handleApplicationManagement(
      payload,
      "application_management",
    );
    if (result?.code == "1") {
      setUserHistory(result?.data);
    } else {
      // const info = { type: "error", message: result?.message };
      // createNotification(info)();
    }
  };
  return (
    <>
      <div className="">
        <table id="viewTable"></table>

        <table id="viewTable">
          <tr>
            <th colspan="6">
              <h4>
                <b>Action History</b>
              </h4>
            </th>
          </tr>

          <tr>
            <td style={{ width: "24%" }}>Action Date</td>
            <td style={{ width: "15%" }}>Action By</td>
            <td style={{ width: "15%" }}>Received Station</td>
            <td style={{ width: "10%" }}>Stage</td>
            <td style={{ width: "20%" }}>Action</td>
            <td style={{ width: "*" }}>Remark / Comments</td>
          </tr>
          {userHistory.map((obj) => (
            <tr>
              <td>
                <h4 style={styles.h4}>{obj?.DateUpdated}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.Username}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.Station}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.StageName}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.RecommendationName}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj.Message}</h4>
              </td>
            </tr>
          ))}
        </table>
      </div>
    </>
  );
};

export default ViewHistoryComponent;
